import { render } from "./NamedMenuSection.vue?vue&type=template&id=6d758605"
import script from "./NamedMenuSection.vue?vue&type=script&lang=js"
export * from "./NamedMenuSection.vue?vue&type=script&lang=js"

import "./NamedMenuSection.vue?vue&type=style&index=0&id=6d758605&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__